<template>
  <v-form @submit="submit" onSubmit="return false;">
    <v-card>
      <v-card-title class="headline py-2">
        Удаление поста
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" class="mx-0"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
 
      <v-card-text class="pt-0">
        <dantser-tree
          label="Выберите пост для передачи данных удаляемого поста"
          ref="postTree"
          :selectMode="1"
          :field="true"
          :source="treedata"
          @node-dblclick="selectNode($event)"
        ></dantser-tree>
        <span class="red--text" v-if="is_container">Для передачи данных должен быть выбран пост</span>
      </v-card-text>
  
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-btn color="error" @click.prevent="submit" type="submit" :disabled="is_container || status.btnDisabled">Удалить</v-btn>
        <span :class="status.className" class="ml-2">{{status.text}}</span>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
  export default {
    name : 'DeleteForm',
    
    props:{
      post_id:{
        type: String,
        required: 'true'
      }
    },
    
    data() {
      return {
        treedata: [],
        is_container: true,
        currentNode: null,
        status:{
          btnDisabled: false,
          text: '',
          className:'success--text darken-1'
        }
      }
    },
    
    created(){
      this.getTree()
    },
    
    methods : {
      getTree(){
        this.$store.dispatch('orgstructure/treePosts', this.post_id).then( response => {
          this.treedata = response.tree
        })
      },
  
      selectNode(node){
        this.currentNode = node
        this.is_container = (node.element_type==='container')
      },
  
      submit(){
        this.status={ btnDisabled: true, text: 'Сохранение', className:'secondary--text lighten-1' }
        
        this.$store.dispatch('orgstructure/deletePost', {id: this.post_id, to_id: this.currentNode.id}).then(response => {
          this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
          this.$emit('change', {
            type:'delete-post',
            container_id: response.container_id,
            post_id:this.post_id
          })
          this.closeDialog()
        }).catch( error => {
          this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
        })
        return false
      },
      
      closeDialog(){
        this.$emit('close-dialog')
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Orgschema/Forms/DeleteForm.vue